export enum PopUpCodes {
    NONE = "",
    CREATE = "C",
    UPDATE = "U",
    DELETE = "D",
    WARNING = "W",
    FILTER = "F",
    INFO = "I",
}
